import { saveAs } from 'file-saver';

// Export array of objects to CSV and trigger download (safe alternative to xlsx)
export function exportToExcel(data, filename = 'export.csv') {
  const rows = Array.isArray(data) ? data : [];
  if (rows.length === 0) {
    const emptyBlob = new Blob(['No data'], { type: 'text/plain;charset=utf-8' });
    saveAs(emptyBlob, filename);
    return;
  }

  const headerSet = new Set();
  rows.forEach((row) => Object.keys(row || {}).forEach((key) => headerSet.add(key)));
  const headers = Array.from(headerSet);

  const escapeCsv = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    const needsQuoting = /[",\n\r]/.test(stringValue);
    const escaped = stringValue.replace(/"/g, '""');
    return needsQuoting ? `"${escaped}"` : escaped;
  };

  const csvLines = [];
  csvLines.push(headers.map(escapeCsv).join(','));
  for (const row of rows) {
    const line = headers.map((h) => escapeCsv(row[h]));
    csvLines.push(line.join(','));
  }

  const csvContent = '\ufeff' + csvLines.join('\r\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  const finalName = filename.toLowerCase().endsWith('.csv') ? filename : `${filename}.csv`;
  saveAs(blob, finalName);
}
